export type Environment = 'development' | 'production' | 'test';

export const APP_ENV: Environment = process.env.NODE_ENV === 'development' ? 'development' : 'production';
export const API_URL: string = APP_ENV === 'development' ? 'https://localhost:5079' : 'https://synergist-webservice.azurewebsites.net/';

export const SEQ_URL: string = APP_ENV === 'development' ? 'http://localhost:5341' : 'https://seq.tezseract.io/';
export const SEQ_API_KEY: string = APP_ENV === 'development' ? undefined : 'ckqP1Y48GTEhHrrLm9n4';
export const SEQ_APPLICATION: string ='Synergist.Web';
// Keep the old password-collecting provisioning page available only as an
// explicit rollback switch during cutover. New builds use identity-first setup.
export const isIdentityFirstOnboardingEnabled = (configuredValue?: string): boolean => {
  if (configuredValue === undefined) {
    return true;
  }

  const normalizedValue = configuredValue.trim().toLowerCase();
  if (normalizedValue === 'true') {
    return true;
  }
  if (normalizedValue === 'false') {
    return false;
  }

  throw new Error('REACT_APP_IDENTITY_FIRST_ONBOARDING must be either true or false.');
};

export const IDENTITY_FIRST_ONBOARDING = isIdentityFirstOnboardingEnabled(
  process.env.REACT_APP_IDENTITY_FIRST_ONBOARDING,
);

export const parseRoleTemplateReplayOrganizationIds = (configuredValue?: string): readonly string[] =>
  Object.freeze((configuredValue ?? '')
    .split(',')
    .map(value => value.trim())
    .filter(value => value.length > 0));

// Deliberately default-off. Capture replay access must be granted to exact,
// immutable organization IDs at build time; the organization name is only a
// secondary synthetic-data guard and can never grant access by itself.
export const ROLE_TEMPLATE_REPLAY_ORGANIZATION_IDS: readonly string[] =
  parseRoleTemplateReplayOrganizationIds(process.env.REACT_APP_ROLE_TEMPLATE_REPLAY_ORGANIZATION_IDS);

// The three media-capture replay routes intentionally share the existing,
// immutable role-template allowlist. They are direct-route-only surfaces for
// the same synthetic Northstar tenant; adding a second, independently managed
// allowlist would make it possible for the capture contracts to drift apart.
export const CAPTURE_REPLAY_ORGANIZATION_IDS: readonly string[] =
  ROLE_TEMPLATE_REPLAY_ORGANIZATION_IDS;

export const NORTHSTAR_CAPTURE_REPLAY_ORGANIZATION = 'Northstar Field Services Training';

export const isNorthstarCaptureReplayOrganization = (
  selectedOrganizationId: string,
  selectedOrganizationName: string,
  allowedOrganizationIds: readonly string[] = CAPTURE_REPLAY_ORGANIZATION_IDS,
): boolean => selectedOrganizationId !== ''
  && selectedOrganizationName === NORTHSTAR_CAPTURE_REPLAY_ORGANIZATION
  && allowedOrganizationIds.includes(selectedOrganizationId);

export enum LogLevel {
    'debug' = 1,
    'info' = 2,
    'warn' = 3,
    'error' = 4
  }

export const LOG_LEVEL: LogLevel = APP_ENV === 'development' ? LogLevel.debug : LogLevel.info;
